import PlatformActions from './PlatformActions'

export default class RELAXEGAMEActions extends PlatformActions {
  constructor(formData) {
    super(formData)
    this.formData = formData

    this.constantTxnData = {
      platform: 'RELAX',
      gameType: 'EGAME',
      gameCode: 'RELAX-EGAME-002',
    }

    this.gameName = '100 Bit Dice'
  }

  getBetMessage(txnList) {
    const { currency, supportPremium } = this.formData

    const txns = txnList.map(({
      userId,
      roundId,
      wagerId,
      betTime,
      betAmount,
    }) => ({
      ...this.constantTxnData,
      gameName: this.gameName,
      userId,
      platformTxId: `RG003-${roundId}_RG003-${wagerId}`, // RG003-38015410_RG003-52429144
      roundId: `RG003-${roundId}`, // RG003-38015410
      betType: null,
      currency,
      betTime, // 2025-11-18T12:58:44.000+08:00
      betAmount,
      jackpotBetAmount: 0,
      gameInfo: {
        betType: '1',
      },
      ...(supportPremium && { isPremium: false }),
    }))

    const message = {
      action: 'bet',
      txns,
    }

    return JSON.stringify(message)
  }

  getSettleMessage(txnList) {
    const txns = txnList.map(({
      userId,
      roundId,
      wagerId,
      updateTime,
      betTime,
      turnover,
      betAmount,
      winAmount,
      isEndRound = true,
    }) => ({
      ...this.constantTxnData,
      gameName: this.gameName,
      userId,
      platformTxId: `RG003-${roundId}_RG003-${wagerId}`, // RG003-38015410_RG003-52429145
      refPlatformTxId: null,
      settleType: 'roundId',
      updateTime, // 2025-11-18T12:58:44.320+08:00
      roundId: `RG003-${roundId}`,
      betType: null,
      betTime,
      txTime: betTime,
      turnover,
      betAmount,
      winAmount,
      jackpotWinAmount: 0,
      gameInfo: {
        betType: '1',
        isEndRound: `${isEndRound}`,
      },
    }))

    const message = {
      action: 'settle',
      txns,
    }

    return JSON.stringify(message)
  }

  getCancelBetMessage(txnList) {
    const txns = txnList.map(({
      userId,
      roundId,
      wagerId,
    }) => ({
      ...this.constantTxnData,
      userId,
      platformTxId: `RG003-${roundId}_RG003-${wagerId}`,
      roundId: `RG003-${roundId}`,
      gameInfo: {
        betType: '1',
      },
    }))

    const message = {
      action: 'cancelBet',
      txns,
    }

    return JSON.stringify(message)
  }
}
